// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/guild.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  guildJoinBypassLevel,
  guildJoinBypassLevelFromJSON,
  guildJoinBypassLevelToJSON,
  guildJoinType,
  guildJoinTypeFromJSON,
  guildJoinTypeToJSON,
  registrationStatus,
  registrationStatusFromJSON,
  registrationStatusToJSON,
} from "./keys";

export const protobufPackage = "structs.structs";

export interface Guild {
  id: string;
  index: string;
  endpoint: string;
  creator: string;
  owner: string;
  joinInfusionMinimum: string;
  joinInfusionMinimumBypassByRequest: guildJoinBypassLevel;
  joinInfusionMinimumBypassByInvite: guildJoinBypassLevel;
  primaryReactorId: string;
  entrySubstationId: string;
  entryRank: string;
  name: string;
  pfp: string;
  bankConvertInFee: string;
  bankConvertOutFee: string;
  charterSolverId: string;
  rankPurchaseBasePrice: string;
  rankPurchaseStepIncrease: string;
  rankPurchaseMinimumRank: string;
  joinByRankPurchaseEnabled: boolean;
}

export interface GuildMembershipApplication {
  guildId: string;
  playerId: string;
  joinType: guildJoinType;
  registrationStatus: registrationStatus;
  proposer: string;
  substationId: string;
}

function createBaseGuild(): Guild {
  return {
    id: "",
    index: "0",
    endpoint: "",
    creator: "",
    owner: "",
    joinInfusionMinimum: "0",
    joinInfusionMinimumBypassByRequest: 0,
    joinInfusionMinimumBypassByInvite: 0,
    primaryReactorId: "",
    entrySubstationId: "",
    entryRank: "0",
    name: "",
    pfp: "",
    bankConvertInFee: "",
    bankConvertOutFee: "",
    charterSolverId: "",
    rankPurchaseBasePrice: "0",
    rankPurchaseStepIncrease: "0",
    rankPurchaseMinimumRank: "0",
    joinByRankPurchaseEnabled: false,
  };
}

export const Guild: MessageFns<Guild> = {
  encode(message: Guild, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.index !== "0") {
      writer.uint32(16).uint64(message.index);
    }
    if (message.endpoint !== "") {
      writer.uint32(26).string(message.endpoint);
    }
    if (message.creator !== "") {
      writer.uint32(34).string(message.creator);
    }
    if (message.owner !== "") {
      writer.uint32(42).string(message.owner);
    }
    if (message.joinInfusionMinimum !== "0") {
      writer.uint32(48).uint64(message.joinInfusionMinimum);
    }
    if (message.joinInfusionMinimumBypassByRequest !== 0) {
      writer.uint32(56).int32(message.joinInfusionMinimumBypassByRequest);
    }
    if (message.joinInfusionMinimumBypassByInvite !== 0) {
      writer.uint32(64).int32(message.joinInfusionMinimumBypassByInvite);
    }
    if (message.primaryReactorId !== "") {
      writer.uint32(74).string(message.primaryReactorId);
    }
    if (message.entrySubstationId !== "") {
      writer.uint32(82).string(message.entrySubstationId);
    }
    if (message.entryRank !== "0") {
      writer.uint32(88).uint64(message.entryRank);
    }
    if (message.name !== "") {
      writer.uint32(98).string(message.name);
    }
    if (message.pfp !== "") {
      writer.uint32(106).string(message.pfp);
    }
    if (message.bankConvertInFee !== "") {
      writer.uint32(114).string(message.bankConvertInFee);
    }
    if (message.bankConvertOutFee !== "") {
      writer.uint32(122).string(message.bankConvertOutFee);
    }
    if (message.charterSolverId !== "") {
      writer.uint32(130).string(message.charterSolverId);
    }
    if (message.rankPurchaseBasePrice !== "0") {
      writer.uint32(136).uint64(message.rankPurchaseBasePrice);
    }
    if (message.rankPurchaseStepIncrease !== "0") {
      writer.uint32(144).uint64(message.rankPurchaseStepIncrease);
    }
    if (message.rankPurchaseMinimumRank !== "0") {
      writer.uint32(152).uint64(message.rankPurchaseMinimumRank);
    }
    if (message.joinByRankPurchaseEnabled !== false) {
      writer.uint32(160).bool(message.joinByRankPurchaseEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Guild {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuild();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.index = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endpoint = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.owner = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.joinInfusionMinimum = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.joinInfusionMinimumBypassByRequest = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.joinInfusionMinimumBypassByInvite = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.primaryReactorId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.entrySubstationId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.entryRank = reader.uint64().toString();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.pfp = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.bankConvertInFee = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.bankConvertOutFee = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.charterSolverId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.rankPurchaseBasePrice = reader.uint64().toString();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.rankPurchaseStepIncrease = reader.uint64().toString();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.rankPurchaseMinimumRank = reader.uint64().toString();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.joinByRankPurchaseEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Guild {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "0",
      endpoint: isSet(object.endpoint) ? globalThis.String(object.endpoint) : "",
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      owner: isSet(object.owner) ? globalThis.String(object.owner) : "",
      joinInfusionMinimum: isSet(object.joinInfusionMinimum) ? globalThis.String(object.joinInfusionMinimum) : "0",
      joinInfusionMinimumBypassByRequest: isSet(object.joinInfusionMinimumBypassByRequest)
        ? guildJoinBypassLevelFromJSON(object.joinInfusionMinimumBypassByRequest)
        : 0,
      joinInfusionMinimumBypassByInvite: isSet(object.joinInfusionMinimumBypassByInvite)
        ? guildJoinBypassLevelFromJSON(object.joinInfusionMinimumBypassByInvite)
        : 0,
      primaryReactorId: isSet(object.primaryReactorId) ? globalThis.String(object.primaryReactorId) : "",
      entrySubstationId: isSet(object.entrySubstationId) ? globalThis.String(object.entrySubstationId) : "",
      entryRank: isSet(object.entryRank) ? globalThis.String(object.entryRank) : "0",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      pfp: isSet(object.pfp) ? globalThis.String(object.pfp) : "",
      bankConvertInFee: isSet(object.bankConvertInFee) ? globalThis.String(object.bankConvertInFee) : "",
      bankConvertOutFee: isSet(object.bankConvertOutFee) ? globalThis.String(object.bankConvertOutFee) : "",
      charterSolverId: isSet(object.charterSolverId) ? globalThis.String(object.charterSolverId) : "",
      rankPurchaseBasePrice: isSet(object.rankPurchaseBasePrice)
        ? globalThis.String(object.rankPurchaseBasePrice)
        : "0",
      rankPurchaseStepIncrease: isSet(object.rankPurchaseStepIncrease)
        ? globalThis.String(object.rankPurchaseStepIncrease)
        : "0",
      rankPurchaseMinimumRank: isSet(object.rankPurchaseMinimumRank)
        ? globalThis.String(object.rankPurchaseMinimumRank)
        : "0",
      joinByRankPurchaseEnabled: isSet(object.joinByRankPurchaseEnabled)
        ? globalThis.Boolean(object.joinByRankPurchaseEnabled)
        : false,
    };
  },

  toJSON(message: Guild): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.index !== "0") {
      obj.index = message.index;
    }
    if (message.endpoint !== "") {
      obj.endpoint = message.endpoint;
    }
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.owner !== "") {
      obj.owner = message.owner;
    }
    if (message.joinInfusionMinimum !== "0") {
      obj.joinInfusionMinimum = message.joinInfusionMinimum;
    }
    if (message.joinInfusionMinimumBypassByRequest !== 0) {
      obj.joinInfusionMinimumBypassByRequest = guildJoinBypassLevelToJSON(message.joinInfusionMinimumBypassByRequest);
    }
    if (message.joinInfusionMinimumBypassByInvite !== 0) {
      obj.joinInfusionMinimumBypassByInvite = guildJoinBypassLevelToJSON(message.joinInfusionMinimumBypassByInvite);
    }
    if (message.primaryReactorId !== "") {
      obj.primaryReactorId = message.primaryReactorId;
    }
    if (message.entrySubstationId !== "") {
      obj.entrySubstationId = message.entrySubstationId;
    }
    if (message.entryRank !== "0") {
      obj.entryRank = message.entryRank;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.pfp !== "") {
      obj.pfp = message.pfp;
    }
    if (message.bankConvertInFee !== "") {
      obj.bankConvertInFee = message.bankConvertInFee;
    }
    if (message.bankConvertOutFee !== "") {
      obj.bankConvertOutFee = message.bankConvertOutFee;
    }
    if (message.charterSolverId !== "") {
      obj.charterSolverId = message.charterSolverId;
    }
    if (message.rankPurchaseBasePrice !== "0") {
      obj.rankPurchaseBasePrice = message.rankPurchaseBasePrice;
    }
    if (message.rankPurchaseStepIncrease !== "0") {
      obj.rankPurchaseStepIncrease = message.rankPurchaseStepIncrease;
    }
    if (message.rankPurchaseMinimumRank !== "0") {
      obj.rankPurchaseMinimumRank = message.rankPurchaseMinimumRank;
    }
    if (message.joinByRankPurchaseEnabled !== false) {
      obj.joinByRankPurchaseEnabled = message.joinByRankPurchaseEnabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Guild>, I>>(base?: I): Guild {
    return Guild.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Guild>, I>>(object: I): Guild {
    const message = createBaseGuild();
    message.id = object.id ?? "";
    message.index = object.index ?? "0";
    message.endpoint = object.endpoint ?? "";
    message.creator = object.creator ?? "";
    message.owner = object.owner ?? "";
    message.joinInfusionMinimum = object.joinInfusionMinimum ?? "0";
    message.joinInfusionMinimumBypassByRequest = object.joinInfusionMinimumBypassByRequest ?? 0;
    message.joinInfusionMinimumBypassByInvite = object.joinInfusionMinimumBypassByInvite ?? 0;
    message.primaryReactorId = object.primaryReactorId ?? "";
    message.entrySubstationId = object.entrySubstationId ?? "";
    message.entryRank = object.entryRank ?? "0";
    message.name = object.name ?? "";
    message.pfp = object.pfp ?? "";
    message.bankConvertInFee = object.bankConvertInFee ?? "";
    message.bankConvertOutFee = object.bankConvertOutFee ?? "";
    message.charterSolverId = object.charterSolverId ?? "";
    message.rankPurchaseBasePrice = object.rankPurchaseBasePrice ?? "0";
    message.rankPurchaseStepIncrease = object.rankPurchaseStepIncrease ?? "0";
    message.rankPurchaseMinimumRank = object.rankPurchaseMinimumRank ?? "0";
    message.joinByRankPurchaseEnabled = object.joinByRankPurchaseEnabled ?? false;
    return message;
  },
};

function createBaseGuildMembershipApplication(): GuildMembershipApplication {
  return { guildId: "", playerId: "", joinType: 0, registrationStatus: 0, proposer: "", substationId: "" };
}

export const GuildMembershipApplication: MessageFns<GuildMembershipApplication> = {
  encode(message: GuildMembershipApplication, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.guildId !== "") {
      writer.uint32(10).string(message.guildId);
    }
    if (message.playerId !== "") {
      writer.uint32(18).string(message.playerId);
    }
    if (message.joinType !== 0) {
      writer.uint32(24).int32(message.joinType);
    }
    if (message.registrationStatus !== 0) {
      writer.uint32(32).int32(message.registrationStatus);
    }
    if (message.proposer !== "") {
      writer.uint32(42).string(message.proposer);
    }
    if (message.substationId !== "") {
      writer.uint32(50).string(message.substationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GuildMembershipApplication {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuildMembershipApplication();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guildId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.playerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.joinType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.registrationStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.proposer = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.substationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GuildMembershipApplication {
    return {
      guildId: isSet(object.guildId) ? globalThis.String(object.guildId) : "",
      playerId: isSet(object.playerId) ? globalThis.String(object.playerId) : "",
      joinType: isSet(object.joinType) ? guildJoinTypeFromJSON(object.joinType) : 0,
      registrationStatus: isSet(object.registrationStatus) ? registrationStatusFromJSON(object.registrationStatus) : 0,
      proposer: isSet(object.proposer) ? globalThis.String(object.proposer) : "",
      substationId: isSet(object.substationId) ? globalThis.String(object.substationId) : "",
    };
  },

  toJSON(message: GuildMembershipApplication): unknown {
    const obj: any = {};
    if (message.guildId !== "") {
      obj.guildId = message.guildId;
    }
    if (message.playerId !== "") {
      obj.playerId = message.playerId;
    }
    if (message.joinType !== 0) {
      obj.joinType = guildJoinTypeToJSON(message.joinType);
    }
    if (message.registrationStatus !== 0) {
      obj.registrationStatus = registrationStatusToJSON(message.registrationStatus);
    }
    if (message.proposer !== "") {
      obj.proposer = message.proposer;
    }
    if (message.substationId !== "") {
      obj.substationId = message.substationId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GuildMembershipApplication>, I>>(base?: I): GuildMembershipApplication {
    return GuildMembershipApplication.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GuildMembershipApplication>, I>>(object: I): GuildMembershipApplication {
    const message = createBaseGuildMembershipApplication();
    message.guildId = object.guildId ?? "";
    message.playerId = object.playerId ?? "";
    message.joinType = object.joinType ?? 0;
    message.registrationStatus = object.registrationStatus ?? 0;
    message.proposer = object.proposer ?? "";
    message.substationId = object.substationId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
